import { render, staticRenderFns } from "./ModalVerHistorico.vue?vue&type=template&id=a0f5a60c&scoped=true&"
import script from "./ModalVerHistorico.vue?vue&type=script&lang=ts&"
export * from "./ModalVerHistorico.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerHistorico.vue?vue&type=style&index=0&id=a0f5a60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f5a60c",
  null
  
)

export default component.exports